import { useTranslations } from '@vocab/react';
import {
  Box,
  IconDelete,
  IconUpload,
  MenuItem,
  MenuRenderer,
} from 'braid-design-system';

import translations from '../.vocab';

interface AvatarOptionsMenuRendererProps {
  children: React.ReactNode;
  onUploadClick: () => void;
  onDeleteClick: () => void;
}

export const AvatarOptionsMenuRenderer = ({
  children,
  onUploadClick,
  onDeleteClick,
}: AvatarOptionsMenuRendererProps) => {
  const { t } = useTranslations(translations);

  return (
    <MenuRenderer
      offsetSpace="none"
      placement="bottom"
      trigger={(triggerProps) => (
        <Box
          aria-label="Profile photo options"
          role="button"
          cursor="pointer"
          {...triggerProps}
        >
          {children}
        </Box>
      )}
    >
      <MenuItem onClick={onUploadClick} icon={<IconUpload />}>
        {t('Upload photo')}
      </MenuItem>
      <MenuItem tone="critical" icon={<IconDelete />} onClick={onDeleteClick}>
        {t('Delete photo')}
      </MenuItem>
    </MenuRenderer>
  );
};
